import type { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingProps = {
  level: HeadingLevel;
  children: ReactNode;
  className?: string;
};

export const Heading = ({ level, children, className }: HeadingProps) => {
  const Tag = `h${level}` as React.ElementType;

  return <Tag className={clsx(styles[`h${level}`], className)}>{children}</Tag>;
};
